var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { equals } from 'ramda';
import * as React from 'react';
import { ReduxProvider } from '../../reduxConnect';
import { editable } from '../../selector/editable';
import DragDropProvider from '../DragDropProvider';
import HotKeyDecorator from '../HotKey/Decorator';
import BlurGate from './BlurGate';
import Inner from './Inner';

var Editable =
/** @class */
function (_super) {
  __extends(Editable, _super);

  function Editable(props) {
    var _this = _super.call(this, props) || this;

    _this.previousState = {};

    _this.onChange = function () {
      var onChange = _this.props.onChange;

      if (typeof onChange !== 'function') {
        return;
      }

      var state = editable(_this.props.editor.store.getState(), {
        id: _this.props.id
      }); // prevent uneeded updates

      var isEqual = equals(state, _this.previousState);

      if (!state || isEqual) {
        return;
      }

      _this.previousState = state;

      var serialized = _this.props.editor.plugins.serialize(state);

      var serializedEqual = equals(_this.previousSerialized, serialized);

      if (serializedEqual) {
        return;
      }

      _this.previousSerialized = serialized;
      onChange(serialized);
    };

    return _this;
  }

  Editable.prototype.componentDidMount = function () {
    if (!this.props.id) {
      throw new Error('The state must have an unique id');
    }

    this.unsubscribe = this.props.editor.store.subscribe(this.onChange);
    this.previousState = null;
    this.previousSerialized = null;
  };

  Editable.prototype.componentWillUnmount = function () {
    this.unsubscribe();
  };

  Editable.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        _b = _a.editor,
        store = _b.store,
        defaultPlugin = _b.defaultPlugin,
        dndBackend = _a.dndBackend;
    return React.createElement(ReduxProvider, {
      store: store
    }, React.createElement(DragDropProvider, {
      dndBackend: dndBackend
    }, React.createElement(HotKeyDecorator, {
      id: id
    }, React.createElement(BlurGate, null, React.createElement(Inner, {
      id: id,
      defaultPlugin: defaultPlugin
    })))));
  };

  return Editable;
}(React.PureComponent);

export default React.memo(Editable);